module.exports = __webpack_public_path__ + "img/fp-logo.207ae83b.webp";